import { useQuery } from 'react-query';
import axios from 'axios';
import { AdminAPI } from '../../../../constants/API';
import { commonHeaders } from '../../../../constants/HeadersAPI';

type EmployeesForFilterResp = {
  users: Array<{
    roleId: number;
    roleDescription: string;
    users?: Array<{
      id: number;
      login: string;
      isActive: boolean;
      isReadOnly: boolean;
      branchIds?: number[];
      queueIds?: number[];
    }>;
  }>;
};

export type EmployeeForReportFilter = {
  id: number;
  label: string;
  queueIds: number[];
  isActive: boolean;
};

export const useGetEmployeesForReportFilter = () => {
  const { data, isFetching } = useQuery(
    ['employeesForReportFilter'],
    () => axios.get<EmployeesForFilterResp>(AdminAPI.getAllEmployees, commonHeaders()),
    {
      select: ({ data }) => {
        const isOperatorRole = (roleId?: number): boolean => roleId === 1;

        const raw =
          data?.users
            ?.filter((role) => isOperatorRole(role.roleId))
            ?.flatMap((role) => role.users ?? [])
            .map((u) => ({
              id: u.id,
              label: u.login,
              queueIds: u.queueIds ?? [],
              isActive: u.isActive
            })) ?? [];

        const uniq = new Map<number, EmployeeForReportFilter>();
        raw.forEach((u) => {
          if (!uniq.has(u.id)) uniq.set(u.id, u);
        });
        return Array.from(uniq.values()).sort((a, b) => a.label.localeCompare(b.label));
      }
    }
  );

  return { employees: data ?? [], isLoading: isFetching };
};

